import React from 'react';
import './style.css';

const Footer = (props) => {
  return (
    <footer className="Footer">
      <section>
        Designed and built with{' '}
        <span className="Footer__Heart">&hearts;</span> by{' '}
        <a
          href="https://www.linkedin.com/in/aditya-indora-822471370/"
          target="_blank"
          rel="noopener noreferrer"
          className="Footer__Link"
        >
          Aditya Indora
        </a>
      </section>


    </footer>
  );
};

export default Footer;
